import axios from 'axios';

/** Keys under `user.preferences` (Mixed) — keep stable for existing users. */
export const TABLE_ROWS_PREF_KEYS = {
  inventoryCertified: 'tableRows_inventory_certified',
  inventoryLots: 'tableRows_inventory_lots',
  orders: 'tableRows_orders',
  clientPortal: 'tableRows_client_portal',
  clientDetailItems: 'tableRows_client_detail_items',
  myAccountItems: 'tableRows_my_account_items',
};

export function coerceRowsPerPage(value, allowed, fallback) {
  const n = parseInt(String(value), 10);
  if (Number.isNaN(n) || !allowed.includes(n)) return fallback;
  return n;
}

export function pickRowsPerPageFromPrefs(prefs, key, allowed, fallback) {
  if (!prefs || prefs[key] == null) return fallback;
  return coerceRowsPerPage(prefs[key], allowed, fallback);
}

export async function saveTableRowsPreference(key, value) {
  await axios.put('/api/users/preferences', { key, value: Number(value) });
}
